export const scrollSX = {
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none', // Hides scrollbar for Chrome, Safari, and Edge
    },
    '-ms-overflow-style': 'none', // Hides scrollbar for IE/Legacy Edge
    '&:hover': {
        scrollbarWidth: 'auto', // For Firefox
        '&::-webkit-scrollbar': {
            display: 'block', // For Webkit
            width: '8px', // Define a width so it looks consistent
        },
    },
    // Optional: Style the scrollbar so it looks cleaner when it appears
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,0.2)',
        borderRadius: '4px',
    },
}

export const formCardStyle = {
    borderRadius: 1,
    mb: 2,
    width: '100%',
    scrollMarginTop: '100px',
    position: 'relative',
    py: 3,
    px: 4,
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollbarGutter: 'stable',
    boxSizing: 'border-box',
};

export const formStyle = {
    '& .MuiOutlinedInput-root': { borderRadius: '4px', bgcolor: 'common.white' },
    '& .MuiOutlinedInput-input': { height: '1em' },
};

export const buttonStyle = {
    fontSize: '12px',
    lineHeight: 1.2,
    p: 1,
    '&.MuiButton-outlined': { bgcolor: 'common.white' },
};

export const optionControlStyle = {
    fontSize: '12px',
    lineHeight: 1.2,
    p: 1,
    fontFamily: (theme) => theme.typography.button.fontFamily,
    fontWeight: 500,
};

export const getOtherTextFieldSx = (isOtherFilledOut) => ({
    mt: 1,
    width: 'auto',
    '& .MuiOutlinedInput-root': {
        backgroundColor: isOtherFilledOut ? 'primary.main' : 'common.white',
        p: 0,
        border: '1px solid transparent',
        borderRadius: '5px',
        width: 'auto',
        transition: `background-color 250ms cubic-bezier(0.4, 0, 0.2, 1),
              box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1)`,
        '& .MuiOutlinedInput-notchedOutline': {
            inset: '-1px',
            '& legend': { display: 'none' },
            borderColor: isOtherFilledOut ? 'primary.main' : 'primary.lighter',
        },
        '&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
            borderColor: isOtherFilledOut ? 'primary.dark' : 'primary.main',
        },
        '&:hover': {
            backgroundColor: isOtherFilledOut ? `primary.dark` : '#f6fbf0',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.main',
        },
        '&.Mui-focused': {
            backgroundColor: 'primary.main',
        },
    },
    '& .MuiOutlinedInput-input': {
        ...optionControlStyle,
        pt: optionControlStyle.p,
        pb: (theme) => `calc(${theme.spacing(optionControlStyle.p)})`,
        width: 'auto',
        height: `${buttonStyle.lineHeight}em`,
        color: isOtherFilledOut ? 'common.white' : 'inherit',
        '&::placeholder': {
            color: 'primary.main',
            opacity: 1,
        },
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input': {
        color: 'common.white',
        '&::placeholder': {
            color: 'common.white',
        },
    },
});
